import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/sectors.json";

export const useSectors = () =>
  useSourceFlowCollection(data).map((i) => ({ ...i, href: `/expertise/${i.url_slug}/` }));

export default useSectors;
